import React, { Component, Fragment } from 'react'


import DemoForm from '../../components/site/Forms/DemoForm'
import Picture from '../../components/Picture'

class NewMainBanner extends Component {
    render() {
        return (
            <Fragment>
                <div className='new-main-banner-v2 new-hero new-hero-variation'>
                    <div className='container'>
                        <div className="column first-col">
                            <div className='title-hero'>
                                <h1 className='title'>Automatize seus pedidos e controle <br /> suas vendas</h1>
                            </div>
                            <div className='main-subheading-container'>
                                <h2 className='description'>
                                    Com o sistema de automação de vendas e e-commerce B2B da Mercos, você organiza os seus processos de vendas, economiza tempo e evita erros integrando tudo ao seu ERP.
                                </h2>
                            </div>
                            <DemoForm darkBg trialAndDemo="comece grátis" buttonShadow inlineBtns />
                            <div className="hero-reviews">
                                <Picture
                                    className='hero-stars'
                                    src='/images/site/new-home/review-stars.png'
                                    alt='Média de avaliações da Mercos nas plataformas digitais'
                                    mobileSrc='/images/site/new-home/review-stars.png'
                                />
                                <div className="reviews-text">Média de avaliações da <strong>Mercos</strong> em:</div>
                                <Picture
                                    className='hero-plataformas'
                                    src='/images/site/new-home/plataformas.png'
                                    alt='Nas plataformas digitais'
                                    mobileSrc='/images/site/new-home/plataformas-mobile.png'
                                />
                            </div>
                        </div>
                        <div className="column">
                            <Picture
                                className='hero-img-full-right hero-img-full-right'
                                src='/images/site/new-home/hero-img.png'
                                alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
                                mobileSrc='/images/site/new-home/hero-img-mobile.png'
                            />
                        </div>
                    </div>



                </div>
            </Fragment>
        )
    }
}

export default NewMainBanner



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/NewMainBanner/NewMainBannerv4.jsx